module.exports = __webpack_public_path__ + "img/excel.fe0d5959.png";